"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nullThrows(x, error) {
    if (typeof x === "undefined" || x === null) {
        throw error instanceof Error ? error : new Error(error);
    }
    return x;
}
exports.default = nullThrows;
//# sourceMappingURL=nullThrows.js.map